import {
  CreateStickyNoteInput,
  StickyNote as StickyNoteGraphql,
  StickyNoteAcknowledgement,
  UpdateStickyNoteInput,
} from '@akin-home/amplify';

import { createStickyNote, StickyNote } from '@akin-home/sticky-notes';
import { grapqhlUserToUserRef } from '@akin-home/users/frontend';

export const stickyNoteGraphqlToModel = (stickyNote: StickyNoteGraphql): StickyNote =>
  createStickyNote({
    id: stickyNote.id,
    habitatID: stickyNote.habitatID || '',
    content: stickyNote.content || '',
    color: stickyNote.color || '',
    owner: stickyNote.owner
      ? grapqhlUserToUserRef(stickyNote.owner)
      : undefined,
    ownerID: stickyNote.ownerID || undefined,
    acknowledgements: (
      stickyNote.acknowledgements as StickyNoteAcknowledgement[] | undefined
    )?.map(stickyNoteAcknowledgementGraphqlToModel),
    sharedWithIDs: stickyNote.sharedWithIDs as string[],
  });

export const serializeStickyNoteForPost = (
  stickyNote: StickyNote
): CreateStickyNoteInput => ({
  habitatID: stickyNote.habitatID,
  content: stickyNote.content,
  color: stickyNote.color,
  ownerID: stickyNote.owner ? stickyNote.owner.id : null,
  sharedWithIDs: stickyNote.sharedWithIDs,
});

export const serializeStickyNoteForPut = (
  stickyNote: StickyNote
): UpdateStickyNoteInput => ({
  id: stickyNote.id,
  habitatID: stickyNote.habitatID,
  content: stickyNote.content,
  color: stickyNote.color,
  ownerID: stickyNote.owner ? stickyNote.owner.id : null,
  sharedWithIDs: stickyNote.sharedWithIDs,
});

export const stickyNoteAcknowledgementGraphqlToModel = ({
  user_id,
  date,
}: StickyNoteAcknowledgement) => ({
  user_id: user_id as string,
  date: date as string,
});
